module.exports = __webpack_public_path__ + "static/media/ocr-union-green.126eb489.svg";